// Global Types
import type {
  $Translate,
} from 'common.language';
// Global Types
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  AdminStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  FormSection,
} from '@vroskus/library-components';

// Helpers
import {
  cleanFormValues,
} from '@vroskus/library-helpers/dist/browser';
import {
  adminStatusLabel,
} from 'common.language';
import {
  defaultUpsertItem,
} from '../../../../helpers';

// Components
import ProfileFields from '../../../fields/ProfileFields';

// Services
import Services from '../../../../services';

// Types
import type {
  $ReducerState,
} from '../../../../redux';

export type $OwnProps = $Translate & {
  id: string;
};

export type $StateProps = {
  auth: $ReducerState<'auth'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  changed: boolean;
};

const adminStatusClass = {
  [AdminStatus.confirmed]: 'bg-success',
  [AdminStatus.suspended]: 'bg-danger',
  [AdminStatus.unconfirmed]: 'bg-light text-dark',
};

class ProfileSettingsSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      changed: false,
    };
  }

  render() {
    const {
      auth: {
        user,
      },
      id,
      t,
    } = this.props;
    const {
      changed,
    } = this.state;

    return (user !== null ? (
      <FormSection
        changed={changed}
        fields={(
          <ProfileFields
            item={user}
            onChange={() => this.setState({
              changed: true,
            })}
          />
        )}
        headerButtons={(
          <span className={`badge rounded-pill ${adminStatusClass[user.Status]}`}>
            {t(adminStatusLabel[user.Status])}
          </span>
        )}
        headerTitle={t('Profile settings')}
        id={id}
        labelClearButton={t('Clear')}
        labelSaveButton={t('Save')}
        onAction={(values) => defaultUpsertItem({
          action: async () => {
            const params = cleanFormValues<$Model<'Admin'>>({
              ...user,
              ...values,
            });

            await Services.Api.updateAuthUser(params);

            this.setState({
              changed: false,
            });
          },
        })}
      />
    ) : null);
  }
}

export default ProfileSettingsSectionView;
